export default "__VITE_ASSET__C66oT5Kj__"